/** Where a signed file URL ended up: in the new tab, or blocked (the view then offers `Url` as a direct link). */
export interface OEPOpenedTab { Blocked: boolean; Url: string }

/** Copy for a blocked tab (implementer copy; the prototype has no such state). */
export const OEP_TAB_BLOCKED = 'Your browser blocked the new tab.';

/**
 * Opens a signed file URL in a new tab without losing the click's user activation: the tab is
 * opened synchronously (about:blank, still inside the click handler), its opener is cut, and only
 * then is the URL fetched and assigned. `noopener` is not passed because it makes window.open
 * return null, which would hide a blocked tab. On a signing failure the blank tab is closed.
 */
export async function OEPOpenInNewTab(getUrl: () => Promise<string>): Promise<OEPOpenedTab> {
    const tab = window.open('about:blank', '_blank');
    if (tab) tab.opener = null;
    try {
        const url = await getUrl();
        if (!tab) return { Blocked: true, Url: url };
        tab.location.href = url;
        return { Blocked: false, Url: url };
    } catch (err) {
        tab?.close();
        throw err;
    }
}
